import { useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faClose, faCircleInfo} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { device } from "../../../utils/breakPoints";


export default function Tooltip({
  tooltipHeadLine = "Tooptip headline",
  tooltipMessage,
}) {
  const [isActive, setIsActive] = useState(false);
  const toggleTooltip = () => {
    setIsActive(!isActive);
  };
  const closeTooltip = () => setIsActive(false);

  let sizeIcon = window.is_ab_custom_pdp ? "lg" : "sm";

  return (
    <Container>
      <Icon onClick={toggleTooltip}>
        <FontAwesomeIcon size={sizeIcon} icon={faCircleInfo} />
      </Icon>
      <MessageBox isActive={isActive} id="tooltipContainer">
        <Title>{tooltipHeadLine}</Title>
        <Message> {tooltipMessage} </Message>
        <Close onClick={closeTooltip}>
          <FontAwesomeIcon icon={faClose} />
        </Close>
      </MessageBox>
    </Container>
  );
}

const Title = styled.p`
  font-family: "Sofia Pro";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
`;
const MessageBox = styled.div`
  text-align: left;
  z-index: 10;
  display: ${(props) => (props.isActive ? "block" : "none")};
  background-color: #fff;
  max-width: 450px;
  padding-left: 17px;
  padding-right: 22px;
  padding-top: 22px;
  padding-bottom: 32px;
  box-sizing: border-box;
  border: 1px solid black;
  position: absolute;
  right: 0;
  width: 600px;
  @media ${device.tablet} {
    width: 100% !important;
    bottom: 0;
    position: fixed;
    left: 0;
  }
`;
const Close = styled.div`
  cursor: pointer;
  position: absolute;
  right: 27px;
  top: 27px;
  color: black;
  font-size: 20px;
`;
const Message = styled.p``;
const Icon = styled.div`
  color: #02455d;
`;
const Container = styled.div`
  position: relative;
  cursor: pointer;
`;
